<template>
  <gj-modal
      id="supplier-quote1"
      :visible.sync="modalVisible"
      :loading="loading"
      size="1200x650"
      :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
      v-on="$listeners"
  >
    <template #header>详情</template>
    <template #content>
      <el-row style="margin-bottom: 12px">
        <el-col :span="8">
          <span class="label">供应商编码</span>
          <span class="value">{{isMeaningful(detailData) && detailData.code}}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">供应商名称</span>
          <span class="value">{{isMeaningful(detailData) && detailData.name}}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">状态</span>
          <span class="value">{{isMeaningful(detailData) &&  isMeaningful(detailData.status) ? disableLowerCaseMap[detailData.status].text : ''}}</span>
        </el-col>
      </el-row>
      <div class="flex-tabs"  id="supplier-quote">
      <el-tabs v-model="activeName" >
        <el-tab-pane label="基本信息" name="basicInfo"><app-supplier-detail-basic
            :detail-data="isMeaningful(detailData) ? detailData : {}"
            :settlement-type-map="settlementTypeMap"
        ></app-supplier-detail-basic></el-tab-pane>
        <el-tab-pane label="收款信息" name="receiveInfo"><app-supplier-detail-receive-info
            :detail-data="isMeaningful(detailData) ? detailData : {}"
        ></app-supplier-detail-receive-info></el-tab-pane>
        <template v-if="$permission('supplier:viewQuote')">
          <el-tab-pane label="报价信息" name="quotedInfo"><app-supplier-detail-quoted-info
              :id="id"
              :code="code"
              :name="isMeaningful(detailData) ? detailData.name : ''"
              :mount-to="$mountTo"
          ></app-supplier-detail-quoted-info></el-tab-pane>
          <el-tab-pane label="报价日志" name="quotedLog"><app-supplier-detail-quoted-log
              :code="code"></app-supplier-detail-quoted-log></el-tab-pane>
        </template>
      </el-tabs>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {isMeaningfulMixin, modalMixIn, userGuideMixin} from "../../../../../minxins";
  import AppSupplierDetailBasic from "./supplier-detail-basic-info";
  import AppSupplierDetailReceiveInfo from "./supplier-detail-receive-info";
  import AppSupplierDetailQuotedInfo from "./supplier-detail-quoted-info";
  import AppSupplierDetailQuotedLog from "./supplier-detail-quoted-log";
  import {getSupplierDetail} from "../../../../../api/purchase";
  import {disableLowerCaseOption} from "../../../../../utils/options";
  import {transformToMap} from "../../../../../utils/common";
  import {settlementType} from "../../../../../utils/options";

  export default {
    name: "supplier-detail",
    components: {
      AppSupplierDetailQuotedLog,
      AppSupplierDetailQuotedInfo, AppSupplierDetailReceiveInfo, AppSupplierDetailBasic},
    mixins: [modalMixIn, isMeaningfulMixin, userGuideMixin],
    props: {
      id: null,
      code: null,
      openIndex: 0,
    },
    created() {
      getSupplierDetail(this.id)
        .then((data) => {
          this.detailData = data;
        }).complete(() => this.loading = false)

      if(this.openIndex == 2){
        this.activeName = 'quotedInfo';
      }
    },
    data() {
      return {
        activeName: 'basicInfo',
        loading: true,
        detailData: null,
        disableLowerCaseMap: transformToMap(disableLowerCaseOption),
        settlementTypeMap: transformToMap(settlementType),
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    font-size: 12px;
  }
  /deep/ .gj-modal--middle-height-auto .el-dialog {
    height: 600px !important;
    width: 1300px !important;
  }

  .label {
    color: #666;
    display: inline-block;
    width: 82px;
    text-align: right;
    padding-right: 10px;
  }

  .value {
    color: #333;
  }
  .flex-tabs{
    flex: 1;
    overflow: auto;
    /deep/ .el-tabs{
      height: 100%;
      display: flex;
      flex-direction: column;
      .el-tabs__content, .el-tab-pane{
        height: 100%;
      }
    }
  }
</style>
